<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11HvE6y/tc-custom/9781453200216.jpg?1733084688889" alt="This image is the cover for the book Passage by Night"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Passage by Night
      </h1>
      <p class="bookDescription body article font2">
        <b>A quest for vengeance leads a man into the deadly underworld of the Cold War in this thriller from the <i>New York Times</i>–bestselling author of <i>The Midnight Bell.</i></b><br/>  <br/> Before Fidel Castro and his revolution, Harry Manning had a prime ocean salvage operation in Batista’s Cuba. Now, he’s just scraping by as a charter captain in the Bahamas, with not much to worry about except where his next drink is coming from, and how long his beautiful lady, Maria, is going put up with his careless ways.<br/>  <br/> His idyll is destroyed in one terrible instant when Maria’s plane is blown out of the sky, and Harry’s descent into misery changes into a burning desire for revenge. His first step: Find the man who put a suitcase bomb onboard the plane. The next step? Survive.<br/>  <br/> Harry’s personal vendetta has put him in the middle of a silent war between the superpowers in which there are no prisoners and no mercy. And he’s going to have to decide how far he’s willing to go for payback—and how much of the world he’s willing to risk.<br/>  <br/> Before <i>The Eagle Has Landed</i> became a blockbuster <i>New York Times</i> bestseller and turned him into a global phenomenon, Jack Higgins honed his skills with no-holds-barred thrillers such as this, one of his earliest works featuring his trademark combination of gunplay, adventure, and men of action.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jack Higgins
      </h2>
      
      <p class="authorDescription body article"><P> Jack Higgins is the <I>New York Times</I> bestselling author of more than sixty thrillers that have sold over 250 million copies worldwide, including <I>The Eagle Has Landed</I> and <I>The Wolf at the Door</I>. Before beginning his writing career, Higgins served in the British Army along the East German border. He lives in the Channel Islands. </P><P> &#160; </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1f18db45